import * as types from "./mutations-types";

export default {
    [types.SET_CONTRACT_TEMPLATES](state, templates) {
        state.contract_templates = templates;
    },
    [types.SET_CURRENT_TEMPLATE](state, template) {
        state.current_template = template;
    },
    [types.UPDATE_TEMPLATE](state, updatedTemplate) {
        const index = state.contract_templates.findIndex(t => t.id === updatedTemplate.id);
        if (index !== -1) {
            state.contract_templates.splice(index, 1, updatedTemplate);
        } else {
            state.contract_templates.push(updatedTemplate);
        }
    },
    [types.SET_LOADING](state, loading) {
        state.loading = loading;
    }
};
